import React from 'react';
import { sizes } from '@sharefiledev/antd-config';
import { Flex, Typography } from 'antd';
import { EmptyIllustration } from './EmptyIllustration';
const { Text } = Typography;
export const TabEmptyState = ({ image, title, message, children, }) => {
    return (React.createElement(Flex, { vertical: true, align: "center", justify: "center", gap: sizes.MS, style: { paddingTop: sizes.MD } }, image !== null && image !== void 0 ? image : React.createElement(EmptyIllustration, null),
        React.createElement(Flex, { vertical: true, align: "center", justify: "center", gap: sizes.SM, style: { maxWidth: 600, textAlign: 'center', textWrap: 'balance' } },
            title && (React.createElement(Text, { strong: true, style: { fontSize: 16 } }, title)),
            message && React.createElement(Text, null, message)),
        children));
};
//# sourceMappingURL=TabEmptyState.js.map